// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"6fb4d903","232":"127dc151","526":"2ce83c63"}[chunkId] + ".chunk.js";
};